<script lang="ts" setup>
  import { IProject } from '@/interfaces/project/project.interface'
  import { toRefs } from 'vue'
  import { i18n } from '@/i18n'
  import { useDateFormatUtil } from '@/utils/useDateFormatUtil'
  import { useRouter } from 'vue-router'
  type ILead = {
    customerNumber: string | null
    projectInterests?: string[]
  } & IProject

  type Iprops = {
    lead: ILead
    index?: number
  }

  const { t } = i18n.global
  const props = defineProps<Iprops>()
  const router = useRouter()
  const { lead, index } = toRefs(props)
</script>

<template>
  <Card class="col col-12 flex-grow-1 border-left-8" :class="[index === 0 ? 'border-primary' : 'blue-gray-400']" @click="() => router.push(`/leads/${lead.id}/media`)">
    <template #title>
      <router-link v-if="lead && lead.id !== null && lead.id !== undefined" :to="`/leads/${lead.id}/media`">
        <div class="flex flex-column gap-1">
          <p class="text-color font-bold text-xl w-15 white-space-nowrap overflow-hidden text-overflow-ellipsis m-0 mb-0 capitalize">
            {{ useDateFormatUtil(lead.meeting, i18n.global.locale === 'en' ? 'dddd, MMM, Do' : 'dddd, MMM, D') }}
          </p>
          <p class="text-color font-bold text-xl w-15 white-space-nowrap overflow-hidden text-overflow-ellipsis m-0 mb-0">
            {{ useDateFormatUtil(lead.meeting, 'h:mm A') }}
          </p>
        </div>
      </router-link>
    </template>
    <template #content>
      <div class="w-full flex flex-column mb-2">
        <div v-if="lead" class="mb-2 font-bold overflow-hidden white-space-nowrap" style="text-overflow: ellipsis">
          {{ lead.name }}
        </div>
        <div class="mb-2 text-600 overflow-hidden white-space-nowrap" style="text-overflow: ellipsis">
          <i v-if="lead.address" class="pi pi-directions"></i>
          {{ lead.address }}
        </div>
        <p class="mb-2 text-600">
          <i class="pi pi-hashtag"></i>
          {{ lead?.customerNumber ?? t('leadCardComponent.noPoNumber') }}
        </p>
        <div class="mb-2 text-600 overflow-hidden white-space-nowrap" style="text-overflow: ellipsis">
          <i v-if="(lead?.projectInterests ?? []).length !== 0" class="pi pi-home"></i>
          {{ (lead?.projectInterests ?? []).length > 0 ? lead?.projectInterests?.join(', ') : t('leadCardComponent.noProjectInterests') }}
        </div>
      </div>
    </template>
  </Card>
</template>

<style scoped lang="scss">
  .border-left-8 {
    border-left: 8px solid;
  }

  .border-blue {
    border-color: #3b82f6;
  }
</style>
